import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData,
  applyAutoSlip,
  CalAm,
  fnGetIotype,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global, globalMenu } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizeBar from "@shared/components/SnResizeBar";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { dateToString } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import { showResizablePopupModal } from "@widgets/CommonModal";
import ExcelUpload_Multi_S01_Validate from "@menu/XTC/SN_MTL_MTR_REG_001_TEX/ExcelUpload_Multi_S01_Validate";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_MTR_REG_001_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
    grid2: React.createRef<SnGridRef>(),
    grid3: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const sheetref1 = useRef<any>(null); // excel download 용
  const sheetref2 = useRef<any>(null); // excel download 용

  const searchRef = useRef<any>(null);
  const { userInfo } = global(); // Login user 정보
  const iotypeRef = useRef<any[]>([]);
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
    sheet2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
    sheet2: [],
  });
  const [selectedDocu, setSelectedDocu] = useState<string>("");

  const [tpItems, setTpItems] = useState<any[]>([]);
  const [locationCode, setLocationCode] = useState<any[]>([]);
  const [noStyles, setNoStyles] = useState<any[]>([]);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          sheet1: rtn.grid.sheet1,
          sheet2: rtn.grid.sheet2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    // 페이지 로드 시 딱 한 번만 미리 조회
    const fetch = async () => {
      const [res1, res2, res3] = await Promise.all([
        fnGetTableById({
          id: "styleconfig_tex",
          params: { cd_firm: userInfo.cd_firm },
        }),
        fnGetTableById({
          id: "codel",
          params: { cd_firm: userInfo.cd_firm, cd_clases: ["SAL061"] },
        }),
        fnGetTableById({
          id: "styleh_tex",
          params: { cd_firm: userInfo.cd_firm, no_style: "" },
        }),
      ]);

      setTpItems(res1);
      setLocationCode(res2);
      setNoStyles(res3);
    };
    fetch();
  }, []);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0 &&
      columns.grid3.lenght > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fnGetIotype("MTL", "1", "6", "");
      iotypeRef.current = data;
    };
    fetchData();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  //#region onSearch
  const onSearch = async (searchData: any) => {
    const modifiedRowsH = getGridCurrent("grid1").getChange();
    const modifiedRowsL = getGridCurrent("grid2").getChange();
    const modifiedRowsL2 = getGridCurrent("grid3").getChange();

    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) {
          return;
        }
      } else if (confirm === undefined) {
        return;
      }
    }
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      const params = {
        id: "sn_mtl_mtr_reg_001_tex_01",
        params: searchDataToUse,
      };

      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      getGridCurrent("grid3").resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
        sheet1: [],
        sheet2: [],
      });
    } catch (error: any) {}
  };
  //#endregion

  //#region onActivate
  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: nodeData.cd_firm,
        cd_biz: nodeData.cd_biz,
        no_io: nodeData.no_io,
        dt_from: nodeData.dt_io,
        dt_to: nodeData.dt_io,
      };
      const searchData = {
        ...formData,
        ...selectedData,
      };
      setFormData(searchData);
      onSearch(searchData);
    }
  };
  //#endregion

  //#region onInsert
  const onInsert = () => {
    try {
      const addedNode = getGridCurrent("grid1").addRow();
      addedNode?.setDataValue("cd_io", addedNode.data?.cd_io);
    } catch (error: any) {}
  };
  //#endregion

  //#region onAddRow1
  const onAddRow1 = () => {
    try {
      return getGridCurrent("grid2").addRow();
    } catch (error: any) {}
  };
  //#endregion

  //#region onAddRow2
  const onAddRow2 = () => {
    try {
      return getGridCurrent("grid3").addRow();
    } catch (error: any) {}
  };
  //#endregion

  //#region onDelete
  const onDelete = async () => {
    if (getGridCurrent("grid1").getDisplayedRowCount() < 1) {
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return; // 사용자가 아니오를 선택하면 함수 종료
    }

    getGridCurrent("grid3").deleteAllRows();

    const focusedRowNodeH = getGridCurrent("grid1").focusedRowNode();

    // tex 항목 삭제
    const nodesToDelete: any[] = [];
    getGridCurrent("grid2").forEachNode((node: RowNode) => {
      if (
        node.data.no_io === focusedRowNodeH.data.no_io &&
        node.data.yn_tex === "Y"
      ) {
        nodesToDelete.push(node);
      }
    });
    nodesToDelete.forEach((node) => {
      getGridCurrent("grid2").deleteRowByNode(node);
    });

    getGridCurrent("grid2").deleteAllRows();
    getGridCurrent("grid1").deleteSelectedRows();

    const realDeletedRows = getGridCurrent("grid1").getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      getGridCurrent("grid3").resetUpdate();
      return;
    }

    return await onSave();
  };
  //endregion

  //#region OnDeleteRow1
  const onDeleteRow1 = () => {
    if (getGridCurrent("grid2").getDisplayedRowCount() < 1) {
      return;
    }
    getGridCurrent("grid2").deleteSelectedRows();
  };
  //#endregion

  //#region OnDeleteRow2
  const onDeleteRow2 = () => {
    if (getGridCurrent("grid3").getDisplayedRowCount() < 1) {
      return;
    }
    getGridCurrent("grid3").deleteSelectedRows();
  };
  //#endregion

  //#region onExcelUpload
  const onExcelUpload = async () => {
    // 신규행이 없으면 Dialog로 띄우기
    const qtiohChanges = getGridCurrent("grid1").getChange().insert;
    if (qtiohChanges.length === 0) {
      await showDialog("alter", "신규행을 추가하시기 바랍니다.");
      return;
    }

    // 신규행 포커스 잡아주기
    let focusedRowHIdx = 0;
    getGridCurrent("grid1").forEachFilteredNode((node: RowNode) => {
      if (node.data.no_io === "" || node.data.no_io === undefined) {
        focusedRowHIdx = node.rowIndex ?? focusedRowHIdx;
      }
    });

    getGridCurrent("grid1").selectAndFocusRow(focusedRowHIdx);

    const excel = (
      <ExcelUpload_Multi_S01_Validate Menuprops={Menuprops} grouping={[]} />
    );

    const result = await showResizablePopupModal({
      title: Menuprops.nm_menu + " 엑셀 업로드",
      children: excel,
      okayBtnText: "확인",
      validation: true,
    });
    if (!result || result == "close") return;

    const line = result[0];
    const lineTex = result[1];

    if (line.length > 0) {
      line.forEach((item: any) => {
        const addedNode = onAddRow1();

        if (addedNode) {
          for (const key in item) {
            addedNode.setDataValue(key, item[key], "noEvent");
          }

          const qtGood = Number(item.qt_good) || 0;
          const qtBad = Number(item.qt_bad) || 0;
          const umK = Number(item.um_k) || 0;
          const amK = Number(item.am_k) || 0;

          addedNode.setDataValue("qt_good", qtGood, "noEvent");
          addedNode.setDataValue("qt_bad", qtBad, "noEvent");
          addedNode.setDataValue("qt", qtGood + qtBad, "noEvent");
          addedNode.setDataValue("um_k", umK, "noEvent");
          addedNode.setDataValue("am_k", amK, "noEvent");
        }
      });
    }

    if (lineTex.length > 0) {
      lineTex.forEach((item: any) => {
        const addedNode = onAddRow2();

        if (addedNode) {
          for (const key in item) {
            switch (key) {
              case "cd_dummy01":
                addedNode.setDataValue(
                  key,
                  locationCode.find((d: any) => d["nm_flag"] === item[key])
                    ?.cd_flag,
                  "noEvent"
                );
                break;
              case "no_style":
                addedNode.setDataValue(key, item[key], "noEvent");
                addedNode.setDataValue(
                  "nm_style",
                  noStyles.find((d: any) => d["no_style"] === item[key])
                    ?.nm_style,
                  "noEvent"
                );
                break;
              default:
                addedNode.setDataValue(key, item[key], "noEvent");
                break;
            }
          }

          const qtW = Number(item.qt_w) || 0;
          const qtDivideW = Number(item.qt_divide_w) || 0;
          const qtB = Number(item.qt_b) || 0;
          const qtDivideB = Number(item.qt_divide_b) || 0;
          const um = Number(item.um) || 0;
          const am = Number(item.am) || 0;

          addedNode.setDataValue("qt_w", qtW, "noEvent");
          addedNode.setDataValue("qt_divide_w", qtDivideW, "noEvent");
          addedNode.setDataValue("qt_b", qtB, "noEvent");
          addedNode.setDataValue("qt_divide_b", qtDivideB, "noEvent");
          addedNode.setDataValue("qt_divide", qtDivideW + qtDivideB, "noEvent");
          addedNode.setDataValue("qt", qtW + qtB, "noEvent");
          addedNode.setDataValue("um_k", um, "noEvent");
          addedNode.setDataValue("um", um, "noEvent");
          addedNode.setDataValue("am_k", am, "noEvent");
          addedNode.setDataValue("am", am, "noEvent");
        }
      });
    }
  };
  //#endregion

  //#region onExcelDownLoad
  const onExcelDownLoad = async () => {
    try {
      const columnKeys1 = sheetref1.current
        ?.getAllDisplayedColumns()
        .filter((col: any) => {
          const cId = col.getColId();
          return cId !== "fixIndicator";
        })
        .map((c: any) => c.getColId());
      const columnKeys2 = sheetref2.current
        ?.getAllDisplayedColumns()
        .filter((col: any) => {
          const cId = col.getColId();
          return cId !== "fixIndicator";
        })
        .map((c: any) => c.getColId());

      const params1 = {
        columnKeys: columnKeys1,
        sheetName: "기본품목",
        skipPinnedBottom: true,
      };

      const params2 = {
        columnKeys: columnKeys2,
        sheetName: "전용품목",
        skipPinnedBottom: true,
      };

      sheetref1.current?.exportMultipleSheetsAsExcel({
        data: [
          sheetref1.current?.getSheetDataForExcel(params1),
          sheetref2.current?.getSheetDataForExcel(params2),
        ],
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      getGridCurrent("grid1").stopEditing();
      getGridCurrent("grid2").stopEditing();
      // H 필수값 체크
      const requiredValuesCheckH =
        getGridCurrent("grid1").requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      // L 필수값 체크
      const requiredValuesCheckL =
        getGridCurrent("grid2").requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return false;
      }

      // L2 필수값 체크
      const requiredValuesCheckL2 =
        getGridCurrent("grid3").requiredValuesCheck();
      if (!requiredValuesCheckL2) {
        return false;
      }

      let qtiohChanges = getGridCurrent("grid1").getChange();
      let qtioChanges = getGridCurrent("grid2").getChange();
      let qtioTexChanges = getGridCurrent("grid3").getChange();
      const headerInserts = qtiohChanges.insert ?? [];
      const lineInserts = qtioChanges.insert ?? [];
      const line2Inserts = qtioTexChanges.insert ?? [];
      const lineDeletes = qtioChanges.delete ?? [];
      const line2Deletes = qtioTexChanges.delete ?? [];
      const lineUpdates = qtioChanges.update ?? [];
      const line2Updates = qtioTexChanges.update ?? [];

      if (
        headerInserts.length > 0 &&
        lineInserts.length === 0 &&
        line2Inserts.length === 0
      ) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      if (
        qtiohChanges.modifiedRowcount === 0 &&
        qtioChanges.modifiedRowcount === 0 &&
        qtioTexChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      let hasInvalid = false;
      let invalidMsg = "";

      for (const row of line2Inserts) {
        switch (row.tp_item) {
          case "PRD":
            if (row.cd_var1 === "") {
              hasInvalid = true;
              invalidMsg = `[${row.cd_item}] 품목의 FIT이 입력되지 않았습니다.`;
            } else if (row.cd_var2 === "") {
              hasInvalid = true;
              invalidMsg = `[${row.cd_item}] 품목의 색상이 입력되지 않았습니다.`;
            } else if (row.cd_var3 === "") {
              hasInvalid = true;
              invalidMsg = `[${row.cd_item}] 품목의 사이즈가 입력되지 않았습니다.`;
            }
            break;
          case "FAB":
            if (row.cd_var2 === "") {
              hasInvalid = true;
              invalidMsg = `[${row.cd_item}] 품목의 색상이 입력되지 않았습니다.`;
            }
            break;
        }
        if (hasInvalid) {
          await showDialog("alter", invalidMsg);
          return false;
        }
      }

      // 신규등록 건 먼저 할당
      if (lineInserts.length > 0 || line2Inserts.length > 0) {
        const maxLineMap = new Map<string | number, number>();

        getGridCurrent("grid2").forEachNode((node: RowNode) => {
          const data = node.data;
          if (data && data.no_io != null) {
            const currentMax = maxLineMap.get(data.no_io) || 0;
            // 기존에 저장된 값보다 더 큰 no_line이 있으면 갱신
            if (data.no_line > currentMax) {
              maxLineMap.set(data.no_io, data.no_line);
            }
          }
        });

        // qtio
        if (lineInserts.length > 0) {
          getGridCurrent("grid2").forEachNode((node: RowNode) => {
            if (node.data.state === "insert" && node.data.no_line === 0) {
              const noIo = node.data.no_io;
              const maxNoLine = maxLineMap.get(noIo) || 0;
              const noLine = maxNoLine + 1;

              node.setDataValue("no_line", noLine);
              maxLineMap.set(noIo, noLine);
            }
          });
        }

        // qtio_tex
        if (line2Inserts.length > 0) {
          const groupMap = new Map<string, number>(); // tex품목 항번 묶을 그룹
          const texMap = new Map<string, number[]>(); // qtio에 생성되어야 할 tex목록

          getGridCurrent("grid3").forEachNode((node: RowNode) => {
            if (node.data.state === "insert" && node.data.no_line === 0) {
              const key = `${node.data.cd_dummy01}_${node.data.no_style}_${node.data.cd_item}_${node.data.cd_var1}_${node.data.cd_var2}`;

              if (groupMap.has(key)) {
                // 이미 같은 그룹 키에 할당된 번호가 있다면 그 번호 사용
                node.setDataValue("no_line", groupMap.get(key));
              } else {
                // 새로운 그룹이면 번호를 증가시키고 Map에 저장
                const noIo = node.data.no_io;
                const maxNoLine = maxLineMap.get(noIo) || 0;
                const noLine = maxNoLine + 1;

                groupMap.set(key, noLine);
                node.setDataValue("no_line", noLine);
                maxLineMap.set(noIo, noLine);

                if (!texMap.has(noIo)) {
                  texMap.set(noIo, []); // 처음 나오는 noIo라면 빈 배열 생성
                }
                texMap.get(noIo)!.push(noLine);
              }
            }
          });

          const headerMap = new Map<string, any>();

          // 헤더를 한 번만 순회하며 Map에 저장
          getGridCurrent("grid1").forEachNode((node: RowNode) => {
            if (node.data) {
              headerMap.set(node.data.no_io, node.data);
            }
          });

          // 추가된 항목 tex그리드 기준으로 qtio 만들어줌
          for (const [noIo, noLines] of texMap) {
            const headerData = headerMap.get(noIo);

            for (const noLine of noLines) {
              let isAdded = false;

              // 이미 qtio그리드에 추가 돼있는지 확인
              getGridCurrent("grid2").forEachNode((node: RowNode) => {
                if (noIo === node.data.no_io && noLine === node.data.no_line) {
                  isAdded = true;
                }
              });

              // 없으면 추가
              if (!isAdded) {
                let cdItem = "";
                let qtGood = 0;
                let qtBad = 0;
                let am = 0;

                getGridCurrent("grid3").forEachNode((node: RowNode) => {
                  if (
                    noIo === node.data.no_io &&
                    noLine === node.data.no_line
                  ) {
                    cdItem = node.data.cd_item;
                    qtGood += node.data.qt_w;
                    qtBad += node.data.qt_b;
                    am += node.data.am;
                  }
                });

                const qt = qtGood + qtBad;
                const um = am !== 0 ? am / qt : 0;

                const addedNode = onAddRow1();

                if (addedNode) {
                  addedNode.setDataValue("no_io", noIo, "noEvent");
                  addedNode.setDataValue("no_line", noLine, "noEvent");
                  addedNode.setDataValue(
                    "cd_dept",
                    headerData.cd_dept,
                    "noEvent"
                  );
                  addedNode.setDataValue("cd_gp", headerData.cd_gp, "noEvent");
                  addedNode.setDataValue(
                    "cd_emp",
                    headerData.cd_emp,
                    "noEvent"
                  );
                  addedNode.setDataValue("dt_io", headerData.dt_io, "noEvent");
                  addedNode.setDataValue("cd_io", headerData.cd_io, "noEvent");
                  addedNode.setDataValue(
                    "fg_slip",
                    headerData.fg_slip,
                    "noEvent"
                  );
                  addedNode.setDataValue(
                    "tp_slip",
                    headerData.tp_slip,
                    "noEvent"
                  );
                  addedNode.setDataValue("fg_io", headerData.fg_io, "noEvent");
                  addedNode.setDataValue(
                    "fg_money",
                    headerData.fg_money,
                    "noEvent"
                  );
                  addedNode.setDataValue(
                    "rt_exch",
                    headerData.rt_exch,
                    "noEvent"
                  );
                  addedNode.setDataValue("cd_wh", headerData.cd_wh, "noEvent");

                  addedNode.setDataValue("cd_item", cdItem, "noEvent");
                  addedNode.setDataValue("yn_tex", "Y", "noEvent"); // tex관리 품목은 안 보여할 항목
                  addedNode.setDataValue("qt", qt, "noEvent");
                  addedNode.setDataValue("qt_good", qtGood, "noEvent");
                  addedNode.setDataValue("qt_bad", qtBad, "noEvent");
                  addedNode.setDataValue("um", um, "noEvent");
                  addedNode.setDataValue("am", am, "noEvent");
                  addedNode.setDataValue("um_k", um, "noEvent");
                  addedNode.setDataValue("am_k", am, "noEvent");
                  addedNode.setDataValue("am_vat", 0, "noEvent");
                  addedNode.setDataValue("um_supply", um, "noEvent");
                  addedNode.setDataValue("am_supply", am, "noEvent");
                }
              }
            }
          }
        }
      }

      // qtio_tex 삭제건이 있을 때 모두 삭제되었으면 qtio항목 삭제
      if (line2Deletes.length > 0) {
        const remainingKeys = new Set<string>();

        getGridCurrent("grid3").forEachNode((node: RowNode) => {
          if (node.data) {
            // no_io와 no_line을 합쳐서 고유한 키 생성
            const key = `${node.data.no_io}_${node.data.no_line}`;
            remainingKeys.add(key);
          }
        });

        const nodesToDelete: any[] = [];

        getGridCurrent("grid2").forEachNode((node: RowNode) => {
          if (node.data) {
            const key = `${node.data.no_io}_${node.data.no_line}`;
            // 만약 grid2에 해당하는 Set에 이 키가 없다면, grid3에서 모두 삭제된 것임
            if (node.data.yn_tex === "Y" && !remainingKeys.has(key)) {
              nodesToDelete.push(node);
            }
          }
        });

        // 모든 tex가 없어지면 grid2에 삭제
        nodesToDelete.forEach((node) => {
          getGridCurrent("grid2").deleteRowByNode(node);
        });
      }

      // 수정된 입고번호를 모음
      const allChanges = [
        ...(lineInserts || []),
        ...(line2Inserts || []),
        ...(lineDeletes || []),
        ...(line2Deletes || []),
        ...(lineUpdates || []),
        ...(line2Updates || []),
      ];
      const modefiedNoIoList = [
        ...new Set(allChanges.map((item) => item.no_io)),
      ];

      modefiedNoIoList.forEach((noIo) => {
        let totalAm = 0;

        const grid3SumMap = new Map<
          number,
          { qtGood: number; qtBad: number; am: number }
        >();
        getGridCurrent("grid3").forEachNode((nodeTex) => {
          if (nodeTex.data.no_io === noIo) {
            const line = nodeTex.data.no_line;
            const prev = grid3SumMap.get(line) || {
              qtGood: 0,
              qtBad: 0,
              am: 0,
            };
            grid3SumMap.set(line, {
              qtGood: prev.qtGood + (nodeTex.data.qt_w || 0),
              qtBad: prev.qtBad + (nodeTex.data.qt_b || 0),
              am: prev.am + (nodeTex.data.am || 0),
            });
          }
        });

        getGridCurrent("grid2").forEachNode((node) => {
          if (noIo === node.data.no_io) {
            // tex품목 qtio에 수량 금액 계산
            if (node.data.yn_tex === "Y") {
              const sums = grid3SumMap.get(node.data.no_line) || {
                qtGood: 0,
                qtBad: 0,
                am: 0,
              };
              const qt = sums.qtGood + sums.qtBad;
              const um = qt !== 0 ? sums.am / qt : 0;

              node.setDataValue("qt", qt, "noEvent");
              node.setDataValue("qt_good", sums.qtGood, "noEvent");
              node.setDataValue("qt_bad", sums.qtBad, "noEvent");
              node.setDataValue("um", um, "noEvent");
              node.setDataValue("um_k", um, "noEvent");
              node.setDataValue("um_supply", um, "noEvent");
              node.setDataValue("am", sums.am, "noEvent");
              node.setDataValue("am_k", sums.am, "noEvent");
              node.setDataValue("am_supply", sums.am, "noEvent");
              totalAm += sums.am;
            }
            // 일반품목 계산
            else {
              node.setDataValue("um", node.data.um_k, "noEvent");
              node.setDataValue("um_supply", node.data.um_k, "noEvent");
              node.setDataValue("am", node.data.am_k, "noEvent");
              node.setDataValue("am_supply", node.data.am_k, "noEvent");
              totalAm += node.data.am_k;
            }
          }
        });

        // 헤더 재계산
        getGridCurrent("grid1").forEachNode((node: RowNode) => {
          if (noIo === node.data.no_io) {
            node.setDataValue("am", totalAm, "noEvent");
            node.setDataValue("am_k", totalAm, "noEvent");
            node.setDataValue("am_vat", 0, "noEvent");
            node.setDataValue("am_supply", totalAm, "noEvent");
          }
        });
      });

      // 다시 할당
      qtiohChanges = getGridCurrent("grid1").getChange();
      qtioChanges = getGridCurrent("grid2").getChange();
      qtioTexChanges = getGridCurrent("grid3").getChange();

      const focusedRowNodeH = getGridCurrent("grid1").focusedRowNode();
      const noSlip = await applyAutoSlip({
        cd_column: "no_io",
        cd_module: "MTL",
        no_line: 6,
        dt: focusedRowNodeH.data.dt_io,
        girdrefs: [
          gridRefs.current["grid1"],
          gridRefs.current["grid2"],
          gridRefs.current["grid3"],
        ],
        inserts: [qtiohChanges, qtioChanges, qtioTexChanges],
        cd_menu: Menuprops.cd_menu,
      });

      // 요청 데이터 구성
      const SaveData = {
        qtioh: qtiohChanges,
        qtio: qtioChanges,
        qtio_tex: qtioTexChanges,
      };

      // 저장 API 호출
      const ok = await fnSave("SN_MTL_MTR_REG_001_TEX_SAVE_01", SaveData);
      if (!ok) return false;

      // 성공적으로 저장된 후 초기화
      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();
      getGridCurrent("grid3").resetUpdate();
      return true;
    } catch (error: any) {
      getGridCurrent("grid1").resetUpdate(true);
      getGridCurrent("grid2").resetUpdate(true);
      getGridCurrent("grid3").resetUpdate(true);
      return false;
    } finally {
      // 저장시 필터깨져서
      const rowIndex = getGridCurrent("grid1").focusedRowNode().rowIndex || 0;
      getGridCurrent("grid1").clearFocus();
      getGridCurrent("grid1").selectAndFocusRow(rowIndex);
    }
  };
  //#endregion

  //#region onBeforeAddRowH
  const onBeforeAddRowH = (): any => {
    try {
      const modifiedRowsH = getGridCurrent("grid1").getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("warning", "수정된 내용이 있습니다.");
        return false;
      }
      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      const updatedRow = {
        cd_firm: userInfo?.cd_firm,
        cd_biz: searchInfo?.cd_biz,
        cd_dept: userInfo?.cd_dept,
        nm_dept: userInfo?.nm_dept,
        cd_gp: userInfo?.cd_gp,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        dt_io: today,
        cd_io: "top1",
        fg_trns: "1",
        tp_trans: "top1",
        rt_exch: 1,
        cd_exch: "000",
        tp_um: "001",
        tp_slip: "6",
        fg_slip: "1",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        yn_autoprocess: "N",
        no_hst: 0,
        no_io: "",
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  //#endregion

  //#region onCellValueChangedH
  const onCellValueChangedH = async (event: any) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const rowCount = getGridCurrent("grid2").getDisplayedRowCount();

    switch (colId) {
      case "cd_io":
        const ioType = iotypeRef.current.find(
          (item) => item.cd_io === rowData.cd_io
        );

        rowNode.setDataValue("fg_io", ioType.fg_io);
        rowNode.setDataValue("fg_money", ioType.fg_money);
        rowNode.setDataValue("fg_map", ioType.fg_map);

        if (rowCount > 0) {
          getGridCurrent("grid2").forEachFilteredNode((node: RowNode) => {
            node.setDataValue("cd_io", rowData.cd_io);
            node.setDataValue("fg_io", ioType.fg_io);
            node.setDataValue("fg_money", ioType.fg_money);
            node.setDataValue("fg_map", ioType.fg_map);
          });
        }
        break;
      case "cd_wh":
        // tex품목은 보이지 않아서
        getGridCurrent("grid2").forEachNode((node: RowNode) => {
          if (rowNode.data.no_io === node.data.no_io) {
            node.setDataValue("cd_wh", rowData.cd_wh);
          }
        });
        getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
          node.setDataValue("cd_wh", rowData.cd_wh);
        });
        break;
      case "dt_io":
        // tex품목은 보이지 않아서
        getGridCurrent("grid2").forEachNode((node: RowNode) => {
          if (rowNode.data.no_io === node.data.no_io) {
            node.setDataValue("dt_io", rowData.dt_io);
          }
        });
        getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
          node.setDataValue("dt_io", rowData.dt_io);
        });
        break;
    }
  };
  //#endregion

  const onFocusedRowChangedH = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      const no_io = selectedRow.no_io;
      getGridCurrent("grid2").selectAndFocusRow(0);
      getGridCurrent("grid3").selectAndFocusRow(0);
      setSelectedDocu(no_io);

      getGridCurrent("grid2").applyFilters({
        no_io: selectedRow.no_io,
        yn_tex: "N",
      });
    } else {
      getGridCurrent("grid2").applyFilters({
        no_io: "",
        yn_tex: "N",
      });
    }
  };

  //#region onBeforeAddRow2
  const onBeforeAddRow2 = (): any => {
    try {
      getGridCurrent("grid1").stopEditing();
      const focusedNodeH = getGridCurrent("grid1").focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const tpTrans = focusedNodeH.data.tp_trans;
      if (tpTrans === undefined || tpTrans === null || tpTrans === "") {
        showDialog("alter", "대체유형은(는) 필수값입니다.");
        return false;
      }

      const updatedRow = {
        cd_firm: focusedNodeH.data?.cd_firm,
        cd_biz: focusedNodeH.data?.cd_biz,
        cd_dept: focusedNodeH.data?.cd_dept,
        cd_gp: focusedNodeH.data?.cd_gp,
        cd_emp: focusedNodeH.data?.cd_emp,
        dt_io: focusedNodeH.data?.dt_io,
        no_io: focusedNodeH.data?.no_io,
        no_line: 0,
        cd_io: focusedNodeH.data?.cd_io,
        fg_slip: focusedNodeH.data?.fg_slip,
        tp_slip: focusedNodeH.data?.tp_slip,
        fg_io: focusedNodeH.data?.fg_io,
        fg_money: focusedNodeH.data?.fg_money,
        fg_map: focusedNodeH.data?.fg_map,
        fg_vat: "11",
        rt_exch: focusedNodeH.data?.rt_exch,
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        um: 0,
        um_k: 0,
        um_supply: 0,
        qt: 0,
        qt_good: 0,
        qt_bad: 0,
        cd_wh: focusedNodeH.data?.cd_wh,
        yn_req: "N",
        yn_tex: "N", // 일반품목
        tp_item: "",
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  //#endregion

  //#region onCellValueChangedL
  const onCellValueChangedL = async (event: any) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    switch (colId) {
      case "cd_item":
        if (
          rowData.cd_item === null ||
          rowData.cd_item === "" ||
          rowData.cd_item === undefined
        ) {
          return;
        }

        const hasInvalid = tpItems.some(
          (d: any) => d["tp_item"] === rowData.tp_item
        );

        if (hasInvalid) {
          showDialog("alter", "전용품목은 전용품목 탭에 입력해 주세요.");
          getGridCurrent("grid2").deleteSelectedRows();
        }
        break;
      case "qt_good": // 양품이면 불량 0
        rowNode.setDataValue("qt_bad", 0, "noEvent");
        rowNode.setDataValue("qt", rowData.qt_good);
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], "rt_exch");
        break;
      case "qt_bad": // 불량이면 양품 0
        rowNode.setDataValue("qt_good", 0, "noEvent");
        rowNode.setDataValue("qt", rowData.qt_bad);
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], "rt_exch");
        break;
      case "um_k":
        rowData.um = rowData.um_k;
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], "rt_exch");
        break;
      case "am_k":
        rowData.am = rowData.am_k;
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], "rt_exch");
        break;
    }
  };
  //#endregion

  //#region onBeforeAddRow3
  const onBeforeAddRow3 = (): any => {
    try {
      getGridCurrent("grid1").stopEditing();
      const focusedNodeH = getGridCurrent("grid1").focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const tpTrans = focusedNodeH.data.tp_trans;
      if (tpTrans === undefined || tpTrans === null || tpTrans === "") {
        showDialog("alter", "대체유형은(는) 필수값입니다.");
        return false;
      }

      const maxNoLineVar = getGridCurrent("grid3").getMaxValue("no_line_var");

      const updatedRow = {
        cd_firm: focusedNodeH.data?.cd_firm,
        dt_io: focusedNodeH.data?.dt_io,
        dt_rcv: focusedNodeH.data?.dt_io,
        no_io: focusedNodeH.data?.no_io,
        cd_io: focusedNodeH.data?.cd_io,
        no_line: 0,
        fg_slip: focusedNodeH.data?.fg_slip,
        no_line_var: maxNoLineVar + 1,
        tp_slip: focusedNodeH.data?.tp_slip,
        fg_io: focusedNodeH.data?.fg_io,
        am: 0,
        am_k: 0,
        um: 0,
        qt: 0,
        qt_w: 0,
        qt_divide_w: 0,
        qt_b: 0,
        qt_divide_b: 0,
        qt_divide: 0,
        cd_wh: focusedNodeH.data?.cd_wh,
        tp_item: "",
        rt_exch: 1,
        cd_dummy01: "",
        no_style: "",
        cd_var1: "",
        cd_var2: "",
        cd_var3: "",
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  //#endregion

  //#region onFocusedRowChangedL2
  const onFocusedRowChangedL2 = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      if (
        selectedRow.no_style === null ||
        selectedRow.no_style === "" ||
        selectedRow.no_style === undefined
      ) {
        getGridCurrent("grid3").applyPopupConditions({
          cd_item: { use_dc_dummy01: "N" },
        });
      } else {
        getGridCurrent("grid3").applyPopupConditions({
          cd_item: { use_dc_dummy01: "Y", dc_dummy01: selectedRow.no_style },
        });
      }
    }
  };
  //#endregion

  //#region onCellValueChangedL2
  const onCellValueChangedL2 = async (event: any) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    switch (colId) {
      case "no_style":
        if (
          rowData.no_style === null ||
          rowData.no_style === "" ||
          rowData.no_style === undefined
        ) {
          getGridCurrent("grid3").applyPopupConditions({
            cd_item: { use_dc_dummy01: "N" },
          });
        } else {
          getGridCurrent("grid3").applyPopupConditions({
            cd_item: { use_dc_dummy01: "Y", dc_dummy01: rowData.no_style },
          });
        }
        break;
      case "cd_item":
        if (
          rowData.cd_item === null ||
          rowData.cd_item === "" ||
          rowData.cd_item === undefined
        ) {
          return;
        }
        const hasInvalid = tpItems.some(
          (d: any) => d["tp_item"] === rowData.tp_item
        );

        if (!hasInvalid) {
          showDialog("alter", "전용품목만 입력가능합니다.");
          getGridCurrent("grid3").deleteSelectedRows();
        } else {
          // 완제품일때만
          if (rowData.tp_item === "PRD") {
            const itemInfo = {
              id: "item",
              params: {
                cd_firm: userInfo.cd_firm,
                cd_items: [rowData.cd_item],
              },
            };
            const data = await fnGetTableById(itemInfo);

            const no_style = data[0].dc_dummy01;
            const cd_var1 = data[0].cd_dummy01;
            const cd_var2 = data[0].cd_dummy02;

            if (no_style !== "") {
              rowNode.setDataValue("no_style", no_style, "noEvent");
              rowNode.setDataValue(
                "nm_style",
                noStyles.find((d: any) => d["no_style"] === no_style)?.nm_style,
                "noEvent"
              );
            }
            if (cd_var1 !== "" && cd_var1) {
              rowNode.setDataValue("cd_var1", cd_var1, "noEvent");
            }

            if (cd_var2 !== "") {
              rowNode.setDataValue("cd_var2", cd_var2, "noEvent");
            }
          }
        }
        break;
      case "qt_w": // 양품이면 불량 0
        rowNode.setDataValue("qt_b", 0, "noEvent");
        rowNode.setDataValue("qt", rowData.qt_w);
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid3"], "rt_exch");
        break;
      case "qt_b": // 불량이면 양품 0
        rowNode.setDataValue("qt_w", 0, "noEvent");
        rowNode.setDataValue("qt", rowData.qt_b);
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid3"], "rt_exch");
        break;
      case "um":
        rowData.um_k = rowData.um;
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid3"], "rt_exch");
        break;
      case "am":
        rowData.am_k = rowData.am;
        CalAm(gridRefs.current["grid1"], gridRefs.current["grid3"], "rt_exch");
        break;
      case "qt_divide_w": // 양품이면 불량 0
        rowNode.setDataValue("qt_divide_b", 0, "noEvent");
        rowNode.setDataValue("qt_divide", rowData.qt_divide_w, "noEvent");
        break;
      case "qt_divide_b": // 불량이면 양품 0
        rowNode.setDataValue("qt_divide_w", 0, "noEvent");
        rowNode.setDataValue("qt_divide", rowData.qt_divide_b, "noEvent");
        break;
      case "no_po":
        {
          const rowCount = getGridCurrent("grid3").getDisplayedRowCount();
          const focusedRowNode = getGridCurrent("grid3").focusedRowNode();

          if (rowCount === 1) return;
          if (!rowData.no_po) return;

          let apply = false;
          getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
            if (
              node.data[colId] === "" ||
              node.data[colId] === null ||
              node.data[colId] === undefined
            )
              apply = true;
          });
          if (!apply) return;

          const confirm = await showDialog(
            "confirm",
            "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
          );

          if (confirm) {
            const visibleIdx = focusedRowNode.rowIndex;

            getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
              if (
                node.data.no_po === "" ||
                node.data.no_po === null ||
                node.data.no_po === undefined
              ) {
                node.setDataValue("no_po", rowData.no_po, "noEvent");
              }
            });
            if (visibleIdx) {
              getGridCurrent("grid3").selectAndFocusRow(visibleIdx);
            }
          }
        }
        break;
      case "cd_dummy01":
        {
          const rowCount = getGridCurrent("grid3").getDisplayedRowCount();
          const focusedRowNode = getGridCurrent("grid3").focusedRowNode();

          if (rowCount === 1) return;
          if (!rowData.cd_dummy01) return;

          let apply = false;
          getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
            if (
              node.data[colId] === "" ||
              node.data[colId] === null ||
              node.data[colId] === undefined
            )
              apply = true;
          });
          if (!apply) return;

          const confirm = await showDialog(
            "confirm",
            "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
          );

          if (confirm) {
            const visibleIdx = focusedRowNode.rowIndex;

            getGridCurrent("grid3").forEachFilteredNode((node: RowNode) => {
              if (
                node.data.cd_dummy01 === "" ||
                node.data.cd_dummy01 === null ||
                node.data.cd_dummy01 === undefined
              ) {
                node.setDataValue("cd_dummy01", rowData.cd_dummy01, "noEvent");
              }
            });
            if (visibleIdx) {
              getGridCurrent("grid3").selectAndFocusRow(visibleIdx);
            }
          }
        }
        break;
    }
  };
  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChangedH,
          onCellValueChanged: onCellValueChangedH,
          onBeforeAddRow: onBeforeAddRowH,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBeforeAddRow: onBeforeAddRow2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onFocusedRowChanged: onFocusedRowChangedL2,
          onCellValueChanged: onCellValueChangedL2,
          onBeforeAddRow: onBeforeAddRow3,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
      sheet2: {
        columns: columns.sheet2,
        dataSource: dataSources.sheet2,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "입고정보" }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid3"]],
              columns: ["no_io"],
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["기본품목", "전용품목"]}
            width={"100%"}
            header={[
              <SnTabHeader
                onBtnAddClick={onAddRow1}
                onBtnDeleteClick={onDeleteRow1}
              />,
              <SnTabHeader
                onBtnAddClick={onAddRow2}
                onBtnDeleteClick={onDeleteRow2}
              />,
            ]}
            body={[
              <div className="flex-1 h-full min-h-0 space-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid2"]} // Grid Name
                  columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                  rowData={grids.grid2.dataSource} // Datasource
                  etcProps={{ rowSelection: "multiple" }}
                  events={grids.grid2.events}
                />
              </div>,
              <div className="flex-1 h-full min-h-0 space-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid3"]} // Grid Name
                  columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                  rowData={grids.grid3.dataSource} // Datasource
                  etcProps={{ rowSelection: "multiple" }}
                  events={grids.grid3.events}
                />
              </div>,
              <div style={{ display: "none" }}>
                <SnGrid
                  ref={sheetref1} // Grid Name
                  columnConfig={grids.sheet1.columns} // 컬럼 설정 전달
                  rowData={grids.sheet1.dataSource} // Datasource
                />
              </div>,
              <div style={{ display: "none" }}>
                <SnGrid
                  ref={sheetref2} // Grid Name
                  columnConfig={grids.sheet2.columns} // 컬럼 설정 전달
                  rowData={grids.sheet2.dataSource} // Datasource
                />
              </div>,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_MTR_REG_001_TEX;
